import React, { useState } from 'react'
import { emitNfe } from '../services/api'

export default function EmitForm({ empCod, serie, numero, onSuccess }: any) {
  const [cliCod, setCliCod] = useState('')
  const [datemi, setDatemi] = useState(new Date().toISOString().slice(0, 10))
  const [vlTot, setVlTot] = useState(0)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!empCod || !serie || !numero) return alert('Documento inválido')
    if (!cliCod) return alert('Informe o cliente (CPF/CNPJ)')

    const payload = {
      header: {
        ntv_empcod: empCod,
        ntv_serie: serie,
        ntv_numero: numero,
        cli_cod: cliCod,
        ntv_datemi: datemi,
        ntv_datsai: datemi,
        ntv_vl_mer: vlTot,
        ntv_vl_tot: vlTot,
        ntv_modelo: '55',
        ftv_tipdco: 'NFE',
        ntv_sitnfe: 'rascunho',
      },
      items: [],
    }

    try {
      setLoading(true)
      await emitNfe(payload)
      alert('Rascunho gravado com sucesso')
      onSuccess && onSuccess()
    } catch (err) {
      console.error(err)
      alert('Erro ao gravar rascunho')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginRight: '0.5rem' }}>
      <input value={cliCod} onChange={(e) => setCliCod(e.target.value)} placeholder="Cliente (CPF/CNPJ)" />
      <input type="date" value={datemi} onChange={(e) => setDatemi(e.target.value)} />
      <input type="number" value={vlTot} onChange={(e) => setVlTot(Number(e.target.value))} placeholder="Valor total" />
      <button type="submit" disabled={loading} style={{ marginLeft: '0.5rem' }}>{loading ? 'Salvando...' : 'Emitir (rascunho)'}</button>
    </form>
  )
}
